// extracted by mini-css-extract-plugin
export var banner = "_3b-0";
export var icon = "_3b-1";
export var message = "_3b-2";